(function ($, $window, $body) {
	const $hero = $(
		'.is-style-masked-hero, .is-style-masked-hero--landing, .is-style-cover-with-circles',
	);
	if (!$hero.length) {
		return;
	}

	// Parallax effect: move blobs at different speeds relative to scroll
	const updateParallax = () => {
		const scrollTop = $window.scrollTop();
		const windowHeight = $window.height();

		// Process each hero element individually
		$hero.each(function () {
			const $currentHero = $(this);
			const heroTop = $currentHero.offset().top;
			const heroHeight = $currentHero.outerHeight();

			// Early exit: skip if hero is far below or above viewport
			const heroBottom = heroTop + heroHeight;
			if (heroBottom < scrollTop - windowHeight || heroTop > scrollTop + windowHeight + 200) {
				return; // continue to next hero
			}

			// Dynamic topPadding based on hero distance from viewport
			const halfViewport = windowHeight / 2;
			const topPadding = heroTop < halfViewport ? 80 : halfViewport;

			// console.log({ heroTop, topPadding });

			// Only start parallax effect when this hero reaches the top of viewport (minus padding)
			// Keep elements in their initial position until then
			let scrollDistance = 0;
			if (scrollTop + topPadding >= heroTop) {
				// Calculate the scroll distance from when this hero reached the top (accounting for padding)
				scrollDistance = scrollTop + topPadding - heroTop;
			}

			// Only update CSS if the value changed (avoid unnecessary DOM operations)
			const newValue = `${scrollDistance}px`;
			const currentValue = $currentHero.css('--scroll-offset');
			if (currentValue !== newValue) {
				$currentHero.css({
					'--scroll-offset': newValue,
				});
			}
		});
	};

	// Throttle scroll events for better performance
	let ticking = false;
	const requestTick = () => {
		if (!ticking) {
			requestAnimationFrame(() => {
				updateParallax();
				ticking = false;
			});
			ticking = true;
		}
	};

	// Initial update
	updateParallax();

	// Update on scroll (throttled)
	$window.on('scroll', requestTick);

	// Update on resize
	$window.on('resize', updateParallax);
})(jQuery, jQuery(window), jQuery('body'));
